function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isFunction } from '../utils';
import CheckboxAll from '../checkboxAll.js';
import Checkbox from '../checkbox.js';
export default {
  computed: {
    isAllCheckboxDisabled: function isAllCheckboxDisabled() {
      var changeablePagerFlatData = this.changeablePagerFlatData;
      return changeablePagerFlatData.length === 0;
    },
    selectionColumnClasses: function selectionColumnClasses() {
      var _ref;

      var prefixCls = this.prefixCls,
          _this$rowSelection = this.rowSelection,
          rowSelection = _this$rowSelection === void 0 ? {} : _this$rowSelection;
      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-selection-column"), true), _defineProperty(_ref, "".concat(prefixCls, "-selection-column-custom"), !!rowSelection.selections), _ref;
    },
    selectionColumn: function selectionColumn() {
      var h = this.$createElement;
      var changeablePagerFlatData = this.changeablePagerFlatData,
          hasRowSelection = this.hasRowSelection,
          _this$rowSelection2 = this.rowSelection,
          rowSelection = _this$rowSelection2 === void 0 ? {} : _this$rowSelection2,
          isAnyColumnsLeftFixed = this.isAnyColumnsLeftFixed,
          isAllCheckboxDisabled = this.isAllCheckboxDisabled,
          getPopupContainer = this.getPopupContainer,
          selectionColumnClasses = this.selectionColumnClasses,
          handleAllSelectionChange = this.handleAllSelectionChange,
          handleSelectionChange = this.handleSelectionChange,
          dropdownPrefixCls = this.dropdownPrefixCls;
      var col = {};

      if (hasRowSelection) {
        var fixed = rowSelection.fixed,
            type = rowSelection.type,
            selections = rowSelection.selections,
            hideDefaultSelections = rowSelection.hideDefaultSelections,
            columnWidth = rowSelection.columnWidth;
        col = {
          key: 'selection-column',
          fixed: fixed || isAnyColumnsLeftFixed,
          className: selectionColumnClasses,
          width: columnWidth,
          cellRender: function cellRender(_, record) {
            var h = this.$createElement;
            return h(Checkbox, {
              "attrs": {
                "type": type,
                "disabled": record.$$_checkboxDisabled,
                "record": record
              },
              "on": {
                "change": handleSelectionChange
              }
            });
          }
        };

        if (type !== 'radio') {
          col.title = h(CheckboxAll, {
            "attrs": {
              "dropdownPrefixCls": dropdownPrefixCls,
              "data": changeablePagerFlatData,
              "disabled": isAllCheckboxDisabled,
              "selections": selections,
              "hideDefaultSelections": hideDefaultSelections,
              "getPopupContainer": getPopupContainer
            },
            "on": {
              "change": handleAllSelectionChange
            }
          });
        }
      }

      return col;
    }
  },
  methods: {
    renderRowSelection: function renderRowSelection() {
      var normalizeColumns = this.normalizeColumns,
          selectionColumn = this.selectionColumn,
          hasRowSelection = this.hasRowSelection;

      var columns = _toConsumableArray(normalizeColumns);

      if (hasRowSelection) {
        columns.unshift(selectionColumn);
      }

      return columns;
    },
    onRowSelectionChange: function onRowSelectionChange(selectedRowKeys, _ref2) {
      var type = _ref2.type,
          record = _ref2.record,
          checked = _ref2.checked,
          changedRowKeys = _ref2.changedRowKeys,
          domEvent = _ref2.domEvent;
      var prevSelectRowKeys = this.selectedRowKeys,
          flatData = this.flatData,
          rowSelection = this.rowSelection,
          setSelectedRowKeys = this.setSelectedRowKeys;
      setSelectedRowKeys(selectedRowKeys);
      var selectedRows = flatData.filter(function (v) {
        return selectedRowKeys.indexOf(v.$$_key) > -1;
      });

      if (isFunction(rowSelection.onChange)) {
        rowSelection.onChange(selectedRowKeys, selectedRows, {
          type: type,
          checked: checked
        }, prevSelectRowKeys);
      }

      if (isFunction(rowSelection[type])) {
        if (type === 'onSelect') {
          rowSelection.onSelect(record, checked, selectedRows, domEvent);
        } else if (type === 'onSelectAll') {
          rowSelection.onSelectAll(checked, selectedRows, flatData.filter(function (v) {
            return changedRowKeys.indexOf(v.$$_key) > -1;
          }), selectedRowKeys, prevSelectRowKeys);
        } else if (type === 'onSelectInvert') {
          rowSelection.onSelectInvert(selectedRows, selectedRowKeys, prevSelectRowKeys);
        }
      }
    },
    handleAllSelectionChange: function handleAllSelectionChange(op, onSelectFn, isDefaultSelection) {
      var _selectedRowKeys;

      var changeablePagerFlatData = this.changeablePagerFlatData,
          onRowSelectionChange = this.onRowSelectionChange;

      var selectedRowKeys = _toConsumableArray(this.selectedRowKeys);

      var changeableFlatDataKeys = changeablePagerFlatData.map(function (v) {
        return v.$$_key;
      });
      var p = {
        type: op,
        checked: false,
        changedRowKeys: []
      };

      switch (op) {
        case 'all':
          p.changedRowKeys = changeableFlatDataKeys.filter(function (k) {
            return selectedRowKeys.indexOf(k) === -1;
          });
          p.type = 'onSelectAll';
          p.checked = true;

          (_selectedRowKeys = selectedRowKeys).push.apply(_selectedRowKeys, _toConsumableArray(p.changedRowKeys));

          break;

        case 'removeAll':
          p.changedRowKeys = changeableFlatDataKeys.filter(function (k) {
            return selectedRowKeys.indexOf(k) > -1;
          });
          p.type = 'onSelectAll';
          p.checked = false;
          selectedRowKeys = selectedRowKeys.filter(function (k) {
            return changeableFlatDataKeys.indexOf(k) === -1;
          });
          break;

        case 'invert':
          p.changedRowKeys = changeableFlatDataKeys;
          selectedRowKeys = changeableFlatDataKeys.filter(function (k) {
            return selectedRowKeys.indexOf(k) === -1;
          });
          p.type = 'onSelectInvert';
          break;

        default:
          break;
      }

      if (!isDefaultSelection && isFunction(onSelectFn)) {
        onSelectFn(changeableFlatDataKeys);
      } else {
        onRowSelectionChange(selectedRowKeys, p);
      }
    },
    handleSelectionChange: function handleSelectionChange(record, e) {
      var onRowSelectionChange = this.onRowSelectionChange,
          type = this.rowSelection.type;
      var checked = e.target.checked;

      var selectedRowKeys = _toConsumableArray(this.selectedRowKeys);

      var key = record.$$_key;

      if (type !== 'radio') {
        var idx = selectedRowKeys.indexOf(key);

        if (checked) {
          if (idx === -1) {
            selectedRowKeys.push(key);
          }
        } else if (idx !== -1) {
          selectedRowKeys.splice(idx, 1);
        }
      } else {
        selectedRowKeys = [key];
      }

      onRowSelectionChange(selectedRowKeys, {
        type: 'onSelect',
        record: record,
        checked: checked,
        domEvent: e.domEvent
      });
    }
  }
};